// removed by extract-text-webpack-plugin
module.exports = {"Spinner":"Spinner-module__Spinner__q7ZQu","Small":"Spinner-module__Small__YjhMy","Tiny":"Spinner-module__Tiny__229fD","Verysmall":"Spinner-module__Verysmall__1R8vv"};


//////////////////
// WEBPACK FOOTER
// ./src/components/UI/Spinner/Spinner.module.css
// module id = 1705
// module chunks = 31